import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
const script = document.createElement('script');
script.src = environment.paymentTechScript;
document.head.appendChild(script);

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
});



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/main.ts